module.exports = __webpack_public_path__ + "img/penalty_full.fec449d9.png";